jQuery(document).ready(function ($) {
	const base = 'gc-order-card';

	$(`.${base}__button`).click(function() {
		$(this).parent().parent().toggleClass(`${base}--active`)
	});

	$(`.${base}__cancel`).click(function() {
		fetch(`/wp-json/growl/orders/deleteRecurring/${$(this).attr('data-id')}`)
		.then((response) => response.json())
		.then(response => {
			if (response.success) {
				location.reload();
			} else {
				showToast('Error')
			}
		})
	});

});